import moment from 'moment';
import { INFOBOX_DISPLAY_TYPE, FIELD_DISPLAY_TYPES } from '../../../constants/enums';

export default class InfoBoxCommon {
    static getSpotLength (uniqueAidaSpotLengths) {
        return uniqueAidaSpotLengths.length === 1 ? `${uniqueAidaSpotLengths[0]}` :
            uniqueAidaSpotLengths.length === 0 ? 0 :
                `(${uniqueAidaSpotLengths.join(', ')})`;
    }

    static getClassicPanelsDelivered(postingData) {
        const today = moment().startOf('day');

        const validData = postingData.filter(week => moment(week.postingDate).isSameOrBefore(today, 'day'));

        if (validData.length === 0) return 0;

        const totalResults = validData.reduce((totals, week) => {
            totals.successfulPostings += week.successfulPostings;
            totals.target += week.target;
            return totals;
        }, { successfulPostings: 0, target: 0 });
        return totalResults.successfulPostings / validData.length;
    };

    static getIdsPanelsDelivered(postingData) {
        const totalDelivered = postingData.reduce((total, week) => {
            total.deliveredIdsPanels += week.deliveredIdsPanels;
            return total;
        }, { deliveredIdsPanels: 0 });
        return totalDelivered.deliveredIdsPanels / postingData.length;
    };

    /**
     * Resolves the INFOBOX_DISPLAY_TYPE for a field from the visibleFields configuration.
     * @param {Object} visibleFields - Dictionary of field name -> array of display types (e.g. { "Audience": ["Estimated", "Delivered"] })
     * @param {string} fieldName - The field name constant from VISIBLE_FIELDS.
     * @returns {string|null} INFOBOX_DISPLAY_TYPE value, or null if field is not visible.
     */
    static getDisplayType(visibleFields, fieldName) {
        if (!visibleFields) return null;
        const key = Object.keys(visibleFields).find(k => k.toLowerCase() === fieldName.toLowerCase());
        const types = key ? visibleFields[key] : undefined;
        if (!types || types.length === 0) return null;
        const hasEstimated = types.includes(FIELD_DISPLAY_TYPES.ESTIMATED);
        const hasDelivered = types.includes(FIELD_DISPLAY_TYPES.DELIVERED);
        if (hasEstimated && hasDelivered) return INFOBOX_DISPLAY_TYPE.BOTH;
        if (hasEstimated) return INFOBOX_DISPLAY_TYPE.TARGET;
        if (hasDelivered) return INFOBOX_DISPLAY_TYPE.DELIVERED;
        return null;
    }
}